module.exports = __webpack_public_path__ + "static/media/white-slash.15ef4161.svg";